import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddPaymentCardDetailComponent } from './add-payment-card-detail.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { CountryAndRegionsModule } from '@fgb/portal-component-library/src/lib/shared/country-and-regions';
import { TopUpAddressModule } from '@fgb/portal-component-library/src/lib/shared/top-up-address';

@NgModule({
  declarations: [AddPaymentCardDetailComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CountryAndRegionsModule,
    LoadingModule,
    FGBSharedModule,
    TopUpAddressModule,
  ],
  exports: [AddPaymentCardDetailComponent],
})
export class AddPaymentCardDetailModule {}
